import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material'
import { sha256 } from 'js-sha256'
import { useContext } from 'react'
import { ApplicationContext } from '../../../App'

interface ViewDetailsDialogProps {
    entry: any
    close: () => void
    open: boolean
}

export const ViewDetailsDialog = ({ open, close, entry }: ViewDetailsDialogProps) => {
    const { identities } = useContext(ApplicationContext)
    let content = ''
    let hash = ''

    if (entry === undefined) {
        return <></>
    }

    if (entry.type === '837' || entry.type === '835') {
        if (entry.edi === undefined) {
            return <></>
        }
        content = entry.edi
        hash = sha256(entry.edi)
    } else if (entry.type === 'message') {
        if (entry.message === undefined) {
            return <></>
        }
        content = entry.message
        hash = sha256(entry.message)
    }

    const sender = identities.find((identity) => identity.did === entry.sender)?.displayName

    return (
        <Dialog open={open} onClose={close} maxWidth="lg">
            <DialogTitle>Details</DialogTitle>
            <DialogContent>
                <Box style={{ display: 'flex', flexDirection: 'column', width: '640px' }}>
                    <TextField
                        label="Content"
                        value={content}
                        style={{ marginTop: '5px' }}
                        inputProps={{ readOnly: true }}
                        multiline
                        rows={8}
                        fullWidth
                    />
                    <TextField
                        label="Hash from Content"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={hash}
                        style={{ marginTop: '20px' }}
                    />
                    <TextField
                        label="Hash from Blockchain"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={entry.ediHash ?? entry.hash}
                        style={{ marginTop: '20px' }}
                    />
                    <TextField
                        label="Sender Blockchain Identity"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={`${entry?.sender} (${sender})`}
                        style={{ marginTop: '20px' }}
                    />
                    <Alert style={{ marginTop: '20px' }} severity="success">
                        Data successfully validated against Blockchain
                    </Alert>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={close}
                >
                    close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
